// Contact numbers are login-only: logged-out taps open the Login/Signup prompt instead of WhatsApp/Call.
let pending = false;

export const contactGate = (user, locked) => {
  if (!user) {
    pending = true;
    window.dispatchEvent(new Event("vb:open-auth"));
    return true;
  }
  if (locked) {
    window.location.reload();
    return true;
  }
  return false;
};

export const reloadIfContactPending = () => {
  if (pending) window.location.reload();
};
